import React from 'react'
import close from "../../../../assets/img/icons/Vector copy.svg";
import { Switch } from 'antd';

const Instancedelivery = ({closeModal ,value,setvalue}) => {
    const onChange = (checked) => {
       setvalue(checked);
      };
  return (
    <div className="ModalBackground GuestCount Instancedelivery">
    <div className="ModalBackground--container p-[25px]">
      <div className="flex justify-between  items-start">
      <div>
      <h2 className="text-[#292D32] text-[24px] font-[700]">
        تحویل فوری
        </h2>
        <p className='mt-8 text-[#797D82] text-[16px]'>درخواست شما بدون پاسخ میزبان تایید میشود .</p>
      </div>
        <button onClick={closeModal}>
          <img src={close} />
        </button>
      </div>
     <div className='Modal_Switch'>
     <Switch defaultChecked onChange={onChange} checked={value}/>
     </div>
      </div>
      </div>
      
  )
}

export default Instancedelivery